import { Avatar, Chip, Skeleton, Stack, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSingleConversationWithAdmin } from "../../../services/common/chatApiFn";
import { setSelectedChat } from "../../../lib/slices/selectedChatSlice";
import { t } from "i18next";

// socket.on("updatedConversation", (updatedConversation) => {
//   console.log("FIRED======>", updatedConversation);

//   if (
//     updatedConversation.conversationId === conversation?.conversationId
//   ) {
//     setConversation((prev) => ({
//       ...prev,
//       lastMessage: updatedConversation.lastMessage,
//       lastUpdated: new Date(),
//       // unreadMessagesCount: updatedConversation.unreadMessagesCount,
//     }));
//   }
// });

// return () => {
//   socket.off("updatedConversation");
// };

function AdminList({ socket }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [conversation, setConversation] = useState(null);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData) {
      fetchAdminConversation();
    }
  }, [userData]);

  useEffect(() => {
    if (socket) {
      // Registeration Room
      socket.emit("connectWithAdmin", { room: "adminRoom" });

      // Listener for new conversations
      const handleNewConversation = (newConversation) => {
        console.log(newConversation, "NEW_CONVERSATION_RECEIVED");

        if (newConversation.conversationId === conversation?.conversationId) {
          setConversation((prev) => ({
            ...prev,
            lastMessage: newConversation.lastMessage,
            lastUpdated: new Date(),
            unreadMessagesCount: newConversation.unreadMessagesCount,
          }));
        }
      };

      socket.on("newConversation", handleNewConversation);

      // Cleanup function to avoid memory leaks
      return () => {
        socket.off("newConversation", handleNewConversation);
        socket.emit("leaveRoom", { room: "adminRoom" });
      };
    }
  }, [socket, conversation]);

  const fetchAdminConversation = async () => {
    try {
      const response = await getSingleConversationWithAdmin(
        userData?._id,
        "Supplier"
      );
      if (response.data.status === "success") {
        const data = response.data.data;
        let user = {};
        data.participants.forEach((val) => {
          user[val.role] = val.userId;
        });

        setConversation({
          ...data,
          user,
        });
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Stack
        p={"6px 6px"}
        borderRadius={2}
        border={"1px solid #615EF0"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ cursor: "default" }}
      >
        <Skeleton variant="circular" width={48} height={48} />
        <Stack flex={1} ml={2}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="80%" />
        </Stack>
      </Stack>
    );
  }

  if (error || !conversation) {
    return (
      <Stack
        p={"6px 6px"}
        borderRadius={2}
        border={"1px solid #615EF0"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ cursor: "default" }}
      >
        <Typography
          fontSize={"0.875rem"}
          fontWeight={"bold"}
          color="error"
          width="100%"
          textAlign="center"
        >
          {t("somethingWentWrong")}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack
      p={"6px 6px"}
      borderRadius={2}
      border={"1px solid #615EF0"}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"flex-start"}
      sx={{ cursor: "pointer" }}
      onClick={() =>
        dispatch(
          setSelectedChat({
            _id: conversation?._id,
            name: "Admin",
            receiverId: conversation?.user?.Admin?._id,
            image: conversation?.user?.Admin?.profileImg,
            conversationId: conversation?.conversationId,
          })
        )
      }
    >
      <Stack
        gap={1}
        direction={"row"}
        width={"100%"}
        alignItems={"center"}
        overflow={"hidden"}
      >
        <Avatar
          src={conversation?.user?.Admin?.profileImg}
          width={48}
          height={48}
        />

        <Stack overflow={"hidden"} width={"100%"}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Typography
              variant="body1"
              // fontSize={"0.875rem"}
              fontWeight={"bold"}
              noWrap
              textTransform={"capitalize"}
            >
              {t("chatWithAdmin")}
            </Typography>
            <Typography fontSize={"0.75rem"}>
              {moment(conversation?.lastUpdated).format("hh:mm a")}
            </Typography>
          </Stack>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Typography variant="body2" color={"#7c7c7c"} noWrap>
              {conversation?.lastMessage || t("welcomeChatMessage")}
            </Typography>
            {conversation?.unreadMessagesCount[userData?._id] > 0 && (
              <Chip
                label={conversation?.unreadMessagesCount[userData?._id] || 0}
                sx={{
                  color: "white",
                  height: "auto",
                  backgroundColor: "primary.main",
                  "& .MuiChip-label": {
                    padding: "2px 8px 2px 8px",
                  },
                }}
              />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default AdminList;
